import { render, staticRenderFns } from "./Bets.vue?vue&type=template&id=5fc1406d&scoped=true"
import script from "./Bets.vue?vue&type=script&lang=js"
export * from "./Bets.vue?vue&type=script&lang=js"
import style0 from "./Bets.vue?vue&type=style&index=0&id=5fc1406d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1406d",
  null
  
)

export default component.exports